// Tracks which method a returning user last authenticated with, so the login
// page can surface a "Last used" hint next to it. Stored in localStorage and
// written on every successful login (email/password or social SSO).

export type LoginMethod = "google" | "email";

// Exported so logout (which calls localStorage.clear()) can preserve this
// key — the "last used" hint is meant to survive across sessions.
export const LAST_LOGIN_METHOD_KEY = "lastLoginMethod";
const VALID_METHODS: readonly LoginMethod[] = ["google", "email"];

export const getLastLoginMethod = (): LoginMethod | null => {
  try {
    const value = localStorage.getItem(LAST_LOGIN_METHOD_KEY);
    // Null-check first, then widen the array for the includes() membership test —
    // so the `as LoginMethod` cast only happens after the guard has proven it.
    return value !== null && (VALID_METHODS as readonly string[]).includes(value)
      ? (value as LoginMethod)
      : null;
  } catch {
    // localStorage may be unavailable (private mode / SSR) — fail soft.
    return null;
  }
};

export const setLastLoginMethod = (method: LoginMethod): void => {
  try {
    localStorage.setItem(LAST_LOGIN_METHOD_KEY, method);
  } catch {
    // Non-critical — skip persistence if storage is unavailable.
  }
};
